import { render } from "./FilterFiltros.vue?vue&type=template&id=dfcc8d8e&ts=true"
import script from "./FilterFiltros.vue?vue&type=script&lang=ts"
export * from "./FilterFiltros.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__